import { Button } from "@/components/ui/button"
import { useRouter } from 'next/navigation'

export default function EventBookings() {
  const router = useRouter()
  return (
    <>
      <h1 className="text-3xl md:text-6xl font-bold text-chart-3 mb-4 md:mb-8">Event Bookings</h1>
      <div className="text-center py-8">
        <div className="text-center">
          <figure className="w-[300px] m-auto mb-[20px]">
            <img src="https://curlified.com/assets/wishlist.4ffd6550.png" alt="empty wishlist" className="cf-img-cover" />
          </figure>
          <p className="text-lg mb-[30px]">Your Orders are empty.</p>
          {/* <Button className="bg-primary text-white" onClick={() => router.push("/")}>Shop Now</Button> */}
        </div>
      </div>
    </>
  )
}